
























  import { Vue, Component, Prop, Watch } from "vue-property-decorator";
  import AddressErrorModal from '@/components/AddressErrorModal.vue'
  import { isWishope } from "../common/utils";

  const HerePlacesAutocompleteProps = Vue.extend({
    methods: {
      isWishope,
    },
});

  @Component({
    components: {
      AddressErrorModal
    }
  })
  
  export default class HerePlacesAutocomplete extends HerePlacesAutocompleteProps {
    @Prop({ type: String, required: true }) readonly label!: string;
    @Prop() readonly place!: any;
    @Prop() needValidateAddress!: boolean;
    @Prop() readonly merchant!: any;

    error = false
    showSearchResults = false
    autocomplete!: any
    currentAddress = ''
    searchResults = []
    $refs!: {
      autocomplete: HTMLInputElement;
    };
    addressError : string = "";
    hereService: any = null;
    debouncedGeocode: any = null;
    selectedPlace: any = null;

    onBlurInput() {
      setTimeout(() => {
        this.showSearchResults = false
        this.checkError()
      }, 350);
    }
  
    displaySuggestions (predictions: any, isOK:boolean) {
      if (!isOK) {
        this.searchResults = []
        return
      }
      this.searchResults = predictions.items;
    }
  
    validateAddressWithApi (latitude: string, longitude: string) {
      return this.$store.dispatch('vas/validateAddressWithApi', { latitude, longitude})
    }
  
    isCurrentAddressValid () {
      return new Promise((resolve, reject) => {
        this.geocodeValue(this.currentAddress, (predictions: any, isOK: any) => {
          if (!isOK) {
            return reject(null)
          }
          if(predictions.items.length > 0)
          {
            this.selectLocation(predictions.items[0]).then(resolve).catch(reject)
          }
        })
      })
    }

    debounce(func: any, wait = 500, immediate: any) {
      var timeout: any;
      const that = this;

      return function executedFunction() {
        var context = that;
        var args = arguments;

        var later = function() {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };

        var callNow = immediate && !timeout;

        clearTimeout(timeout);

        timeout = setTimeout(later, wait);

        if (callNow) func.apply(context, args);
      };
    }

    geocodeValue(input: string, callback: any) {
        if(input == '')
        {
          return;          
        }

        if(!this.hereService)
        {
          return;
        }
        
        // Call the geocode method with the geocoding parameters,
        // the callback and an error callback function (called if a
        // communication error occurs):
        this.hereService.geocode(
            {
                q: input,
                in: "countryCode:ITA"
            },
            (result: any) => {
                callback(result, true);
            },
            (error: any) => {
                callback(error, false);
                console.log(error, "error");
            }
        );
    }

    async checkError()
    {
      this.addressError = "";
      if(this.currentAddress?.length === 0 || (this.currentAddress?.length > 0 && !this.selectedPlace?.address?.houseNumber))
      {
        this.currentAddress = "";
        this.addressError = "Seleziona l'indirizzo completo scegliendo tra quelli suggeriti";
        this.$emit('select', { address: null, place: null })

        return false;
      }      

      return true;
    }
  
    async selectLocation (prediction: any) {
      this.error = false
      this.showSearchResults = false
      // const details: any = await this.getPlaceDetails(prediction)
      const details = prediction;
  
      this.addressError = "";
  
      this.selectedPlace = this.fillInAddress(details)
      if(!this.checkError())
      {
        return;
      }
  
      try {
        // const { lat, lng }: any = details.geometry.location.toJSON()
        const lat = this.selectedPlace.position.lat;
        const lng = this.selectedPlace.position.lng;
        // await this.validateAddressWithApi(lat, lng)
        this.currentAddress = this.selectedPlace.title
  
      } catch (error) {
        this.error = true
        this.currentAddress = this.selectedPlace.title
        throw error
      }
    }
  
    created () {
      if (this.place) {
        // this.currentAddress = addressStringFromPlace(this.address)
        this.currentAddress = this.place.title;
      }
    }

    mounted() {
        const isLibraryLoaded = this.checkLibrary();
        this.loadHereLibrary();

        this.debouncedGeocode = this.debounce(
          () => { 
            this.geocodeValue(this.currentAddress, this.displaySuggestions);
          },
          125, 
          null
        );

    }
  
    @Watch('currentAddress')
    handleAddress () {
      this.debouncedGeocode();
    }
  
    fillInAddress (place: any) {
      const address = place.title;

      this.$emit('select', { address, place })
      return place
    }

    /**
     * HERE Service
     */
     async initHereService() {
        // eslint-disable-next-line no-undef
        let platform = await new (window as any).H.service.Platform({
            apikey: '88HCRQAuDovIbTaw6sN81zJPlfm6CYqVesFbQ6McwI0'
        });

        // Get an instance of the geocoding service:
        this.hereService = platform.getSearchService();
    }    

    checkLibrary() {
        const libraryLoaded = !!(window && (window as any).H && (window as any).H.service);
        console.log("isLibraryLoaded? ", libraryLoaded);
        return libraryLoaded;
    }

    loadHereLibrary() {
        const script = document.createElement('script');
        script.src = 'https://js.api.here.com/v3/3.1/mapsjs-core.js';
        script.async = true;
        document.head.appendChild(script);
        script.onload = () => {
            const script2 = document.createElement('script');
            script2.src = 'https://js.api.here.com/v3/3.1/mapsjs-service.js';
            script2.async = true;
            document.head.appendChild(script2);
            script2.onload = () => {
                const loaded = this.checkLibrary();
                if (loaded) this.onLibraryLoaded();
            };
        };
    }

    onLibraryLoaded() {
        this.initHereService();
    }    
  }
  